// extracted by mini-css-extract-plugin
export default {"wrapper":"ExtendedEditor_wrapper__ljRac","topBar":"ExtendedEditor_topBar__v3-go","subContent":"ExtendedEditor_subContent__qh3GJ","content":"ExtendedEditor_content__F2CQs"};